import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { IResetPasswordEventData } from '../../interfaces';
import { emailRegex, phoneRegex } from '../../constants';
import { ERecipientTypeEnum } from '../../enums/recipient-type.enum';

@Component({
  standalone: false,
  selector: 'irembogov-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PasswordResetComponent {
  constructor(private authService: AuthService) {}
  @Input() title: string | undefined;
  @Input() errorMessage: string | undefined;
  @Input() errorTitle: string | undefined;
  @Input() authorizationBaseUrl!: string;
  @Input() authorizationClientId!: string;
  @Input() showErrorTitle = false;
  @Input() description: string | undefined;
  @Input() buttonActionLabel: string | undefined;
  @Input() isLoading = false;
  @Input() resendEmailUrl = '';
  @Input() showBackToLogin = true;
  @Input() userNameLabel = '';
  @Input() userNamePlaceholder = '';
  @Input() userNameValidationMessage = '';
  @Input() passwordLabel = 'Password';
  @Input() confirmPasswordLabel = '<PASSWORD>';
  @Input() submitLabel = 'Submit';
  @Input() showResendButton = true;
  @Input() resendLinkQuestion = 'Did not recieve any otp?';
  @Input() resendLinkLabel = 'Resend Otp';
  @Input() showCancelButton = true;
  @Input() cancelLinkLabel = 'Back To Login';
  @Input() mainErrorMessage = '';
  @Input() accountNotFoundErrorTitle =
    'Sorry, the email you entered does not match any account.';
  @Input() accountNotFoundErrorMessage =
    'Sorry, the email you entered does not match any account. Please check your login details or contact your Account Admin.';
  @Input() accountNotActiveErrorTitle = 'Sorry, your account is inactive.';
  @Input() accountNotActiveErrorMessage =
    'Sorry, your account is inactive. Please contact your Account Admin.';
  @Output() resend: EventEmitter<undefined> = new EventEmitter<undefined>();
  @Output() goBack: EventEmitter<undefined> = new EventEmitter<undefined>();
  @Output() formSubmit: EventEmitter<IResetPasswordEventData> =
    new EventEmitter<IResetPasswordEventData>();

  resetPasswordForm: FormGroup = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      this.emailOrPhoneValidator(),
    ]),
  });

  hasError = false;
  errorTheme: 'danger' | 'warning' = 'danger';

  onFormSubmit() {
    if (this.resetPasswordForm.invalid) {
      this.errorMessage = 'Please fill in your email address/phone number';
      return;
    }
    const username = this.resetPasswordForm.controls['username'].value;

    this.formSubmit.emit({
      username,
      usernameType: emailRegex.test(username)
        ? ERecipientTypeEnum.EMAIL_ADDRESS
        : ERecipientTypeEnum.PHONE_NUMBER,
    });
  }

  setError(title: string, message: string, theme: 'danger' | 'warning') {
    this.hasError = true;
    this.errorTheme = theme;
    this.errorMessage = message;
    this.errorTitle = title;
  }

  emailOrPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      if (!emailRegex.test(value) && !phoneRegex.test(value)) {
        return { emailOrPhoneInvalid: true };
      }
      return null;
    };
  }
}
